export default class QueryWhereNode {
	/** @type {any[] | undefined} */
	children = undefined;

	/**
	 * @param {any} node
	 */
	constructor(node = null) {
		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.class_kid = node?.class_kid ?? null;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.kid = node?.kid ?? null;

		/** @type {?string} */
		this.name = node?.name ?? null;

		/** @type {number} */
		this.inherits_extended = 0;

		/** @type {import('@knitiv/api-client-javascript').LinkerKNode} */
		this.linker_kid = node?.linker_kid ?? '0';

		/** @type {any} */
		this.linker_info = node?.linker_info;

		/** @type {'up' | 'down' | null} */
		this.flow = node?.flow ?? null;

		/** @type {?import('@knitiv/api-client-javascript').KNode} */
		this.relation_kid = node?.relation_kid ?? null;

		/** @type {import('@knitiv/api-client-javascript').TypeKid} */
		this.type = node?.type ?? node?.type_kid ?? 'K_NODE;STRING';
	}

	export() {
		return {
			class_kid:         this.class_kid,
			flow:              this.flow,
			inherits_extended: this.inherits_extended,
			kid:               this.kid,
			linker_info:       this.linker_info,
			linker_kid:        this.linker_kid,
			name:              this.name,
			relation_kid:      this.relation_kid,
			type:              this.type,
		};
	}

	getChildren() {
		return this.children;
	}

	async init(/** @type {Promise<any>} */ callback) {
		if (Array.isArray(this.children)) {
			this.children.length = 0;
		}
		else {
			this.children = [];
		}
		const children = await callback;
		this.children = children.result.filter(
			(/** @type {any} */ child) => child.kid !== undefined,
		);
	}
}
